import AboutLanding from './AboutLanding/AboutLanding.js';
import TextSection from './TextSection/TextSection.js';
import Profiles from './Profiles/Profiles.js';

function About() {
    return (
        <>
            <AboutLanding/>
            <TextSection/>
            <Profiles/>
        </>
    );
}

export default About;
